// Most popular AKC-registered breeds, alphabetized. "Mixed Breed" is
// included as the first "special" option so pet parents who don't know or
// don't care about a specific breed have a native pick. The Overview &
// Add-dog inputs use this as a <datalist> so users can either pick from
// the list OR type a custom breed (rare breeds, working-line variants, etc.).
export const POPULAR_BREEDS = [
  "Australian Cattle Dog",
  "Australian Shepherd",
  "Basset Hound",
  "Beagle",
  "Belgian Malinois",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Border Collie",
  "Boston Terrier",
  "Boxer",
  "Brittany",
  "Bulldog",
  "Cane Corso",
  "Cavalier King Charles Spaniel",
  "Chihuahua",
  "Cocker Spaniel",
  "Collie",
  "Dachshund",
  "Dalmatian",
  "Doberman Pinscher",
  "English Cocker Spaniel",
  "English Springer Spaniel",
  "French Bulldog",
  "German Shepherd Dog",
  "German Shorthaired Pointer",
  "Golden Retriever",
  "Great Dane",
  "Havanese",
  "Labrador Retriever",
  "Maltese",
  "Mastiff",
  "Miniature American Shepherd",
  "Miniature Schnauzer",
  "Mixed Breed",
  "Newfoundland",
  "Papillon",
  "Pembroke Welsh Corgi",
  "Pomeranian",
  "Poodle",
  "Portuguese Water Dog",
  "Pug",
  "Rhodesian Ridgeback",
  "Rottweiler",
  "Shetland Sheepdog",
  "Shiba Inu",
  "Shih Tzu",
  "Siberian Husky",
  "Vizsla",
  "West Highland White Terrier",
  "Whippet",
  "Yorkshire Terrier",
];

export const BREEDS_DATALIST_ID = "popular-breeds-list";

// Renders the <datalist> once per page; multiple <input list> can reference it.
export function BreedsDatalist() {
  return (
    <datalist id={BREEDS_DATALIST_ID}>
      {POPULAR_BREEDS.map((b) => (
        <option key={b} value={b} />
      ))}
    </datalist>
  );
}
